import { render } from "./ArticleSmallCard.vue?vue&type=template&id=49d662f2"
import script from "./ArticleSmallCard.vue?vue&type=script&lang=js"
export * from "./ArticleSmallCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/itide.sk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__